import { MDBCol, MDBContainer, MDBFooter, MDBIcon, MDBRow } from 'mdb-react-ui-kit'
import React from 'react'

const Footer = () => {
    const date = new Date().getFullYear()
    
    return (
        <MDBFooter bgColor='light' className='text-center text-lg-start text-muted'>
            <section className='d-flex justify-content-center justify-content-lg-center p-4 border-bottom'>
                <div className='me-4 d-none d-lg-block'>
                    <span>Get connected with us on social networks:</span>
                </div>

                <div>
                    <a href='' className='me-4 text-reset'>
                        <MDBIcon fab icon="facebook-f" />
                    </a>
                    <a href='' className='me-4 text-reset'>
                        <MDBIcon fab icon="twitter" />
                    </a>
                    <a href='' className='me-4 text-reset'>
                        <MDBIcon fab icon="google" />
                    </a>
                    <a href='' className='me-4 text-reset'>
                        <MDBIcon fab icon="instagram" />
                    </a>
                    <a href='' className='me-4 text-reset'>
                        <MDBIcon fab icon="linkedin" />
                    </a>
                    <a href='' className='me-4 text-reset'>
                        <MDBIcon fab icon="github" />
                    </a>
                </div>
            </section>

            <section className=''>
                <MDBContainer className='text-center text-md-start mt-5'>
                    <MDBRow className='mt-3'>
                        <MDBCol sm="6" md="6" lg="4" className='mx-auto mb-4'>
                            <h6 className='text-uppercase fw-bold mb-4'>
                                <MDBIcon icon="gem" className="me-3" />
                                SafeDine
                            </h6>
                            <p>
                            Our food delivery platform stands out by prioritizing transparency and customer safety, offering a unique service in the industry. We empower customers to make informed choices by providing comprehensive health violation details for each restaurant listed, ensuring they can enjoy their favorite cuisines with confidence and access crucial information about the hygiene practices of the eateries they choose.
                            </p>
                        </MDBCol>

                        <MDBCol sm="6" md="6" lg="3" className='mx-auto mb-md-0 mb-4'>
                            <h6 className='text-uppercase fw-bold mb-4'>Contact</h6>
                            <p>
                                <MDBIcon icon="home" className="me-2" />
                                <a href="https://maps.app.goo.gl/WXxYmbQbMm9syt6H9">360 Huntington Ave, Boston, MA 02115</a>
                            </p>
                            <p>
                                <MDBIcon icon="envelope" className="me-3" />
                                <a href='mailto:info@example.com'>info@example.com</a>
                            </p>
                            <p>
                                <MDBIcon icon="phone" className="me-3" /> <a href='tel:+ 01 234 567 88'>+ 01 234 567 88</a>
                            </p>
                            <p>
                                <MDBIcon icon="print" className="me-3" /> <a href='fax:+415.123.4567'>+415.123.4567</a>
                            </p>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </section>

            <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
                ©{date} Copyright:
                <a className='text-reset fw-bold' href='/'>
                    SafeDine.com
                </a>
            </div>
        </MDBFooter>
    )
}

export default Footer